import axios from "axios"
import { constant } from "./ApiConstants"
import { storageContainsToken, getTokenFromStorage } from "./ApiUtils"

// Resusable requests template
export const ApiRequest = () => {
  const config = { baseURL: constant.baseUrl }
  const instance = axios.create(config)
  return instance
}

export const ApiRequestWithToken = () => {
  const config = { baseURL: constant.baseUrl }
  if (storageContainsToken()) {
    const token = getTokenFromStorage()
    config.headers = { Authorization: `Bearer ${token}` }
  }
  const instance = axios.create(config)
  return instance
}

const ApiRequestWithMultiPart = () => {
  const config = { baseURL: constant.baseUrl }
  if (storageContainsToken()) {
    const token = getTokenFromStorage()
    config.headers = {
      Authorization: `Bearer ${token}`,
      "content-type": `multipart/form-data; `
    }
  }
  const instance = axios.create(config)
  return instance
}
// End of reusable template requests

export const register = formData => {
  return ApiRequest().post("v1/auth/register", formData)
}

export const login = formData => {
  return ApiRequest().post("v1/auth/login", formData)
}

export const forgotPassword = formData => {
  return ApiRequest().post("v1/auth/forgot-password", formData)
}

export const resetPassword = formData => {
  return ApiRequest().post("v1/auth/reset-password", formData)
}

export const createEvent = formData => {
  return ApiRequestWithToken().post("v1/events", formData)
}

export const getProducts = page => {
  return ApiRequestWithToken().get(`/v2/products?page=${page}&limit=12`)
}

export const getEventTypes = () => {
  return ApiRequestWithToken().get("/v1/event-type")
}

export const createRegistries = formData => {
  return ApiRequestWithToken().post("v1/registries", formData)
}

export const updateRegistries = (id, formData) => {
  return ApiRequestWithToken().put(`v1/registries/${id}`, formData)
}

export const createOrder = formData => {
  return ApiRequestWithToken().post("v1/orders", formData)
}

export const createPartialOrder = formData => {
  return ApiRequestWithToken().post("v1/orders/partial", formData)
}

export const createCashOrder = formData => {
  return ApiRequestWithToken().post("v1/orders/cash", formData)
}

export const getOrders = () => {
  return ApiRequestWithToken().get("v1/orders")
}

export const generateLink = (orderId, callBackUrl) => {
  return ApiRequestWithToken().get(
    `v1/orders/${orderId}/pay?callback_url=${callBackUrl}`
  )
}

export const confirmPayment = (trxref, reference) => {
  return ApiRequestWithToken().get(
    `v1/confirm-transaction?trxref=${trxref}&reference=${reference}`
  )
}

export const getAllRegistries = () => {
  return ApiRequestWithToken().get("v1/registries")
}

export const getAllUserEvent = () => {
  return ApiRequestWithToken().get("/v1/events")
}

export const getRegistries = id => {
  return ApiRequestWithToken().get(`v1/registries${id}`)
}

export const deleteProductFromRegistry = (registry, id) => {
  return ApiRequestWithToken().delete(`v1/registries/${registry}/products`, {
    data: { products: [`${id}`] }
  })
}

export const getRegistryById = id => {
  return ApiRequestWithToken().get(`/v1/registries/${id}`)
}

export const addProductToRegistry = (registryId, data) => {
  return ApiRequestWithToken().put(
    `/v1/registries/${registryId}/add-product`,
    data
  )
}
export const getAllBanks = () => {
  return ApiRequest().get("v1/banks")
}

export const getRegistryBySlug = slug => {
  return ApiRequest().get(`v1/registries/name/${slug}`)
}

export const getCategories = () => {
  return ApiRequest().get("v1/categories")
}

export const getCategoryById = id => {
  return ApiRequest().get(`v1/categories/${id}`)
}

export const convertToCash = (orderId, formData) => {
  return ApiRequestWithToken().patch(`v1/orders/${orderId}/convert`, formData)
}

export const shipGift = (orderId, formData) => {
  return ApiRequestWithToken().patch(`v1/orders/${orderId}/ship`, formData)
}

export const resolveAccountInfo = (accountNumber, bankCode) => {
  return ApiRequestWithToken().get(
    `v1/banks/resolve?account_number=${accountNumber}&bank_code=${bankCode}`
  )
}

export const getOneOrder = id => {
  return ApiRequestWithToken().get(`v1/orders/${id}/`)
}

export const addCoCelebrant = (id, form) => {
  return ApiRequestWithToken().put(`/v1/registries/${id}/add-user`, form)
}

export const getPersonalRegistries = () => {
  return ApiRequestWithToken().get("v1/registries/me")
}

export const updateRegistryImages = (id, data) => {
  return ApiRequestWithMultiPart().put(`v1/registries/${id}/headers`, data)
}

export const createContribution = (id, data) => {
  return ApiRequestWithMultiPart().post(
    `v1/registries/${id}/contributions`,
    data
  )
}
